import classNames from 'classnames';
import { Placeholder } from '@wordpress/components';
import ImageCarousel from '../image-carousel';
import ImageCarouselProvider from '../image-carousel/image-carousel-provider';
import './styles.scss';

const CardLink = ({
    url,
    children,
    ...props
}) => {
    if (!url) {
        return (
            <div {...props}>
                {children}
            </div>
        );
    }

    return (
        <a href={url} {...props}>
            {children}
        </a>
    );
};

const Card = ({
    id,
    isLoading,
    isContainer,
    hoverHandler,
    url,
    title,
    facts,
    altFacts,
    images,
    useMediumImages = false,
    lazyLoadAttribute = {}
}) => {

    if (isLoading || isContainer) {
        return (
            <div className={classNames({
                'card': true,
                'card--is-loading': isLoading,
                'card--is-container': isContainer
            })}>
               <figure className="card__images">
                    {isContainer && <Placeholder label="Placeholder" withIllustration={true} className="card__images-placeholder" />}
               </figure>
               <h2></h2>
               <span className="card__facts"></span>
               <span className="card__altfacts"></span>
            </div>
        );
    }

    return (
        <CardLink 
            url={url}
            className="card" 
            onMouseLeave={() => {
                hoverHandler(null);
            }}
            onMouseEnter={() => {
                hoverHandler(id);
            }}>
                <figure className="card__images">
                    <ImageCarouselProvider images={images}>
                        <ImageCarousel useMediumImages={useMediumImages} lazyLoadAttribute={lazyLoadAttribute} />
                    </ImageCarouselProvider>
                </figure>
                <h2 dangerouslySetInnerHTML={ { __html: title } }></h2>
                {facts &&
                    <span className="card__facts">
                        {facts}
                    </span>
                }

                {altFacts &&
                    <span className="card__altfacts">
                        {altFacts}
                    </span>
                }
        </CardLink>
    );
};

export default Card;